"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableOperators = exports.getSelectTypeFields = exports.fieldType = void 0;
const FIXED_TYPES = ['country', 'currency', 'rating', 'opinion-scale', 'image', 'document', 'from-multi-select', 'travel-date', 'relation', 'reference', 'preference'];
const fieldType = field => {
  const schema = field.schema;
  const type = field.type ? field.type.toLowerCase() : null;
  if (FIXED_TYPES.includes(type)) {
    return type;
  }
  if (!schema) {
    return 'unknown';
  }
  if (!schema.type) {
    return 'unknown';
  }
  const realType = typeof schema.type === 'string' ? schema.type : schema.type[0];
  if (realType === 'string') {
    if (!schema.format && !schema.enum) {
      return 'text';
    }
    if (schema.enum) {
      if (type === 'country') {
        return 'country';
      }
      if (type === 'currency') {
        return 'currency';
      }
      return 'select';
    }
    switch (schema.format) {
      case 'uri':
      case 'iri':
        return 'url';
      case 'date-time':
        return 'datetime';
      case 'date':
      case 'time':
      case 'email':
        return schema.format;
      case 'idn-email':
        return 'email';
      default:
        return 'text';
    }
  }
  if (realType === 'array' && schema.items.type === 'string') {
    return 'multi-select';
  }
  if (realType === 'number') {
    return 'number';
  }
  if (realType === 'integer') {
    if (type === 'rating') {
      return 'rating';
    }
    if (type === 'opinion-scale') {
      return 'opinion-scale';
    }
    return 'integer';
  }
  if (realType === 'boolean') {
    return 'boolean';
  }
  return 'unknown';
};
exports.fieldType = fieldType;
const STANDARD_OPERATORS = new Set(['eq', 'not_eq', 'in', 'not_in', 'empty']);
const TEXT_OPERATORS = new Set([...STANDARD_OPERATORS, 'like', 'not_like']);
const DATETIME_OPERATORS = new Set([...STANDARD_OPERATORS, 'before', 'after']);
const NUMERIC_OPERATORS = new Set([...STANDARD_OPERATORS, 'gte', 'gt', 'lte', 'lt']);
const fieldTypeOperators = {
  date: DATETIME_OPERATORS,
  time: DATETIME_OPERATORS,
  datetime: DATETIME_OPERATORS,
  select: STANDARD_OPERATORS,
  country: STANDARD_OPERATORS,
  currency: STANDARD_OPERATORS,
  'multi-select': STANDARD_OPERATORS,
  'from-multi-select': TEXT_OPERATORS,
  text: TEXT_OPERATORS,
  url: TEXT_OPERATORS,
  email: TEXT_OPERATORS,
  number: NUMERIC_OPERATORS,
  integer: NUMERIC_OPERATORS,
  rating: NUMERIC_OPERATORS,
  'opinion-scale': NUMERIC_OPERATORS,
  'travel-date': DATETIME_OPERATORS,
  // The other typical operator types don't make sense for boolean fields
  boolean: new Set(['eq', 'not_eq']),
  // Searching on arbitrary files is meaningless
  document: new Set(),
  image: new Set(),
  preference: STANDARD_OPERATORS,
  relation: STANDARD_OPERATORS,
  reference: TEXT_OPERATORS,
  unknown: STANDARD_OPERATORS
};
const getSelectTypeFields = fields => fields.filter(field => {
  const type = (0, exports.fieldType)(field);
  return type === 'multi-select' || type === 'select' || type === 'country' || type === 'currency' || type === 'from-multi-select' || type === 'preference';
});
exports.getSelectTypeFields = getSelectTypeFields;
const availableOperators = field => {
  const type = (0, exports.fieldType)(field);
  return fieldTypeOperators[type] || STANDARD_OPERATORS;
};
exports.availableOperators = availableOperators;
